import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/Header/HeaderAnatomy.mdx";
import Usage from "../../Docs/Components/Header/HeaderUsage.mdx";

import Examples from "../../Docs/Components/Header/HeaderExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Header"
            description="Use the header to describe your page or large section of content."
            apiSources={["azure-devops-ui/Components/Header/Header.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;